import styled from "styled-components";

export const CssHome = styled.div`
  width: 100%;
  z-index: 0;
  position: relative;


  /* HERO */
  .hero {
    background: #e00000; /* vermelho do layout */
    min-height: 800px;
    padding-top: 78px; /* por causa do header fixo */
    overflow: hidden;
  }

  .hero__inner {
    max-width: 1366px;
    margin: 0 auto;
    padding: 140px 24px 40px;
    display: grid;

    /* texto grande à esquerda + área do vídeo/geo à direita */
    grid-template-columns: minmax(0, 1fr) 610px;

    gap: 40px;
    align-items: start;
  }

  .hero__title {
    margin: 0 0 64px;
    font-size: 70px;
    line-height: 0.95;
    letter-spacing: -0.03em;
    font-weight: 700;
    color: #7cf3ff; /* azul claro do layout */
    max-width: 860px; /* controla largura do bloco do texto */
  }


  .tB {
    display: inline-block;
    position: relative;
  }

  .tB .service {
    display: inline-block;
    position: relative;
    color: #7cf3ff;
    transition: opacity 220ms ease;
    font-weight: 300;
  }

  	.tB .responsibility {
		display: inline-block;
		opacity: 0;
		color: #7cf3ff;
		margin-left: 0;
		transform: translateX(-24px);
		transition:
			opacity 900ms ease,
			transform 900ms ease,
			margin-left 900ms ease;
	}

	.tB.is-swap .responsibility {
		opacity: 1;
		transform: translateX(0);
		margin-left: 10px;
		transition-delay: 500ms;
	}

  /* Quando swapDone = true:
		- risca "service"
		- mostra responsibility
	*/
  .tB.is-swap .service {
    opacity: 1;
  }

  .tB .service::after {
		content: "";
		position: absolute;
		left: -2px;
		right: -2px;
		top: 65%;
		height: 4px;
		background: #7cf3ff;
		transform: translateY(-50%) scaleX(0);
		transform-origin: left center;
		opacity: 0;
	}

	.tB.is-swap .service::after {
		opacity: 1;
		animation: strikeService 700ms ease forwards;
	}


	@keyframes strikeService {
		0% {
			opacity: 1;
			transform: translateY(-50%) scaleX(0);
		}
		100% {
			opacity: 1;
			transform: translateY(-50%) scaleX(1);
		}
	}

  /* Links de serviços */
  .heroJobs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 26px;
    margin-top: 0;
    margin-left: 6px;
    max-width: 520px;
  }

  .heroJobs__item {
    position: relative;
    display: inline-flex;
    align-items: center;
    color: #f6efd8;
    text-decoration: none;
    font-size: 48px;
    line-height: 0.92;
    font-weight: 700;
    letter-spacing: -0.04em;
    padding-left: 20px;
    transition:
      color 280ms ease,
      transform 280ms ease;
  }

  .heroJobs__item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 7px;
    height: calc(100% - 8px);
    min-height: 42px;
    background: #7cf3ff;
    transition:
      width 280ms ease,
      transform 280ms ease;
  }

  .heroJobs__item:hover {
    color: #7cf3ff;
    transform: translateX(8px);
  }

  .heroJobs__item:hover::before {
    width: 10px;
    transform: skewX(-8deg);
  }

  /* Botão */
  .btnTalk {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 58px;
    margin-left: 6px;
    padding: 14px 70px;
    min-width: 220px;
    border: 2px solid #7cf3ff;
    color: #e00000;
    text-decoration: none;
    font-weight: 900;
    text-transform: lowercase;
    background: #7cf3ff;
    position: relative;
    transform: skewX(-18deg);
    transition:
      opacity 280ms ease,
      transform 280ms ease,
      box-shadow 280ms ease;
  }

  .btnTalk::before {
    content: "";
    position: absolute;
    inset: 7px -10px -7px 10px;
    border: 2px solid #f6efd8;
    z-index: -1;
    pointer-events: none;
    transition:
      inset 280ms ease,
      border-color 280ms ease;
  }

  .btnTalk span {
    transform: skewX(18deg);
    display: inline-block;
  }

  .btnTalk:hover {
    opacity: 1;
    transform: translateY(-3px) skewX(-18deg);
  }

  .btnTalk:hover::before {
    inset: 4px -7px -4px 7px;
    border-color: #7cf3ff;
  }

  /* Vídeo/GIF placeholder */
  .hero__left {
    align-self: start;
  }

	.hero__right {
		position: relative;
		min-height: 520px;
		padding-top: 185px;
		opacity: 0;
		transform: translateY(42px);
		filter: blur(10px);
		transition:
			opacity 900ms ease,
			transform 900ms ease,
			filter 900ms ease;
		transition-delay: 220ms;
	}

  	.mediaBox {
		width: 570px;
		max-width: 100%;
		background: #111;
		position: relative;
		z-index: 2;
		margin-left: -70px;
		transform: translateY(0);
	}

	.mediaBox__placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: rgba(255, 255, 255, 0.65);
		letter-spacing: 0.12em;
		font-weight: 700;
		overflow: hidden;

		iframe {
			width: 100%;
			min-height: 335px;
			border: 0;
			display: block;
		}

		img {
			width: 100%;
			height: 105%;
		}
	}


	/* geometria decorativa */
	.geo {
		position: absolute;
		right: -95px;
		top: 0;
		width: 470px;
		z-index: 1;
		opacity: 0;
		transform: translateY(12px) scale(0.45);

		img {
			width: 100%;
		}
	}

		.is-ready .geo {
			animation: geoReveal 1100ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
			animation-delay: 850ms;
		}

		@keyframes geoReveal {
			0% {
				opacity: 0;
				transform: translateY(12px) scale(0.45);
			}		
			100% {
				opacity: 0.75;
				transform: translateY(0) scale(1);
			}
		}

  /* BRANDS */
  .brands {
    background: #e00000;
    padding: 40px 24px 80px;
  }

  .brands__title {
    margin: 0 auto 28px;
    max-width: 1180px;
    text-align: center;
    font-size: 40px;
    color: #fff;
    font-weight: 700;

    opacity: 0;
    transform: translateY(30px);
    filter: blur(8px);
    transition: all 0.8s ease;
  }

  .brands__title.is-visible {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }

  .brands__grid {
    max-width: 1180px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 18px;
    align-items: center;
  }

  .brandCard {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    opacity: 0;
    transform: translateY(10px);
    animation: homeBrandIn 520ms ease forwards;

	 cursor: pointer;
 	 transition:
		transform 280ms ease,
		filter 280ms ease,
		opacity 280ms ease;
  }

	.brandCard img {
		max-height: 22px;
		width: auto;
		filter: brightness(0) invert(1);
		opacity: 0.95;

		transform: scale(1);
		transition:
			transform 280ms cubic-bezier(0.22, 1, 0.36, 1),
			filter 280ms ease,
			opacity 280ms ease;
		will-change: transform;
	}

	.brandCard:hover {
		transform: translateY(-4px);
	}

	.brandCard:hover img {
		transform: scale(1.22);
		opacity: 1;
		filter: brightness(0) invert(1) drop-shadow(0 8px 14px rgba(0, 0, 0, 0.22));
	}

  /* logos maiores */
  .brandCard img.logo-big {
    max-height: 45px;
  }

  .brandCard img.logo-extraLarge {
    max-height: 60px;
  }

  /* logos horizontais */
  .brandCard img.logo-wide {
    max-height: 30px;
  }

  /* logos pequenos */
  .brandCard img.logo-small {
    max-height: 22px;
  }

  @keyframes homeBrandIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* =========================
	HERO INTRO ANIMATION
	slide + blur (texto)
	video sobe
	========================= */

  .hero__left {
    opacity: 0;
    transform: translateY(26px);
    filter: blur(10px);
    transition:
      opacity 900ms ease,
      transform 900ms ease,
      filter 900ms ease;
    transition-delay: 120ms;
  }

  .hero__right {
    opacity: 0;
    transform: translateY(42px);
    filter: blur(10px);
    transition:
      opacity 900ms ease,
      transform 900ms ease,
      filter 900ms ease;
    transition-delay: 220ms;
  }

  /* quando a página “ficar pronta” */
  .is-ready .hero__left {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }

  .is-ready .hero__right {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }

  /* vídeo sobe um pouco a mais (efeito elegante) */
  .is-ready .mediaBox {
    transform: translateY(-10px);
    transition: transform 1100ms cubic-bezier(0.2, 0.9, 0.2, 1);
  }

  /* estado inicial do video */
  .mediaBox {
    transform: translateY(0);
  }

  .hero__title,
  .heroJobs,
  .btnTalk {
    opacity: 0;
    transform: translateY(14px);
    transition:
      opacity 800ms ease,
      transform 800ms ease;
  }

  .is-ready .hero__title {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 140ms;
  }

  .is-ready .heroJobs {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 240ms;
  }

  .is-ready .btnTalk {
    opacity: 1;
    transform: translateY(0) skewX(-18deg);
    transition-delay: 340ms;
  }

	/* MOBILE: reduz blur pra ficar mais leve */

	/* RESPONSIVO */	
  	@media (max-width: 1400px) {
		.hero__inner {
			grid-template-columns: minmax(0, 1fr) 560px;
		}
		.hero__title {
			max-width: 980px;
		}

		.hero__right {
			padding-top: 170px;	
		}
	}

	@media (max-width: 1280px) {
		.hero__title {
			font-size: 81px;
		}

		.hero__right {
			padding-top: 150px;
		}

		.hero__inner {
			    padding: 120px 24px 5px;
		}

		.hero{
			    min-height: 730px;
		}

		.brands {
			    padding: 15px 24px 80px;
		}
	}  	


	@media (max-width: 1440px) {
	.geo {
			right: -10px;
		}
	}


	@media (max-width: 1024px) {
		.geo {
			right: 28px;
		}

		.hero{
			    min-height: 690px;
		}

		.hero__title {
			white-space: normal;
			font-size: 55px;
		}

		.brands__grid {
			gap: 3px;
		}

		.heroJobs__item{
			font-size: 42px;
		}

		.mediaBox{
			width: 500px;
			margin-left: -80px;
		}

		.hero__right {
			padding-top: 145px;
		}

		.hero__inner {
			padding: 110px 24px 1px;
			grid-template-columns: minmax(0, 1fr) 470px;
		}
	}

	

	@media (max-width: 980px) {
		.hero__left,
		.hero__right {
		filter: blur(6px);
		}

		.hero__inner {
		grid-template-columns: 1fr;
		}

		.hero__title {
		font-size: 46px;
		}

		.hero__right {
		padding-top: 35px;
		}

		.mediaBox {
		margin-top: 24px;
		width: 100%;
		/* height: 290px; */
		margin-left: 0;
		}

		.geo {
		right: 0;
		top: -40px;
		opacity: 0.55;
		width: 220px;
		}

		.brands__grid {
		grid-template-columns: repeat(3, 1fr);
		}
	}

	@media (max-width: 520px) {

		.mediaBox__placeholder {
			
			iframe {
				width: 100%;
				min-height: 210px;
				border: 0;
				display: block;
			}
		
		}

		 .btnTalk {	
		     padding: 12px 44px;
		     min-width: 180px;
		     margin-top: 38px;
		 }


		.geo{
			top: -20px;
        	width: 90px;
		}

		.hero__title {
			font-size: 33px;
		}

		.hero__right {
			min-height: 230px;
		}

		.brandCard {
			padding: 15px 5px;
		}

		.brands {
			padding: 10px 24px 30px;
		}

		.brands__title {
			font-size: 28px;
		}

		.brandCard img {
			max-height: 18px;
		}

		.brands__grid {
			grid-template-columns: repeat(2, 1fr);
		}

		.heroJobs {
			gap: 18px;
			margin-left: 0;
		}

		.heroJobs__item {
			font-size: 34px;
			padding-left: 16px;
		}

		.heroJobs__item::before {
			width: 5px;
			min-height: 30px;
		}
	}
`;


export const CssJobs = styled.div`
  width: 100%;
  z-index: 2;
  position: relative;

  /* =========================
     JOBS
  ========================= */
  .jobs {
    position: relative;
    background: #f6efd8; /* bege do print */
     /* overflow: hidden;  */
    padding: 0 0 90px; /* base */
  }

  /* container */
  .jobs__inner {
    position: relative;
    z-index: 2;

    max-width: 1366px;
    margin: 0 auto;

    padding: 130px 20px 0;

    display: grid;
    grid-template-columns: 460px minmax(0, 1fr);
    gap: 90px;
    align-items: start;
  }

  /* =========================
     FX TOPO ESQUERDO
     ✅ agora dispara com .jobs.is-in
  ========================= */
  .jobsFx {
    position: absolute;
    top: 18px;
    z-index: 3;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transition:
      opacity 1100ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 1100ms cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
  }

  .jobsFx--branco {
    width: 80px;
    top: -120px;
    left: -10px;
    z-index: 2;

    /* vem da esquerda */
    transform: translateX(-120px);
  }

  .jobsFx--azul {
    width: 250px;
    top: -56px;
    left: -10px;
    z-index: 1;

    /* vem da direita */
    transform: translateX(120px);
  }

  .jobs.is-in .jobsFx--branco,
  .jobs.is-in .jobsFx--azul {
    opacity: 1;
    transform: translateX(0);
  }

  /* =========================
     SETA TOPO DIREITO (setaAzul.png)
     ✅ agora dispara com .jobs.is-in
     ✅ vem de baixo, passa um pouco do topo e volta
  ========================= */
  .jobsArrowTop {
    position: absolute;
    right: 55px;
    top: -60px;

    width: 140px;
    z-index: 9999;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transition: opacity 400ms ease;
    will-change: transform;
  }

  	.jobs.is-in .jobsArrowTop {
		opacity: 1;
	}

  /* =========================
     LEFT
  ========================= */
  .jobs__left {
    position: relative;
    z-index: 2;
  }

  .jobs__typing {
    font-size: 58px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: #e00000;
    position: relative;
    z-index: 4;
  }

  .jobsLine {
    min-height: 66px;
  }

  .jobsCaret {
    display: inline-block;
    width: 10px;
    height: 46px;
    margin-left: 8px;
    background: rgba(224, 0, 0, 0.75);
    transform: translateY(8px);
    animation: jobsBlink 900ms infinite;
  }

  @keyframes jobsBlink {
    0%,
    49% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }

  .jobsBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 34px;

    padding: 12px 30px; 
    border: 2px solid #e00000;
    color: #e00000; 

    text-decoration: none;
    font-weight: 800;
    text-transform: lowercase;

    background: transparent;
    transform: skewX(-25deg);
    transition: 0.35s ease;
    z-index: 4;
    position: relative;

	img{
		width: 20px;
		height: auto;	
		transform: none;
		 transform: skewX(8deg);
	}
	:hover{
		transition: 0.5s;
		 border: 3px solid #e00000;		
	}
  }

  .jobsBtn span {
    transform: skewX(16deg);
    display: inline-block;
  }

 
  /* R (fundo)
     ✅ agora dispara com .jobs.is-in
  */
  .jobsR {
    position: absolute;
    left: -120px;
    bottom: -100px;
    width: 400px;
    z-index: 0;

    opacity: 0;
    transform: scale(0.86);
    transition:
      opacity 1100ms ease,
      transform 1100ms cubic-bezier(0.16, 1, 0.3, 1);
    transition-delay: 240ms;

    pointer-events: none;
    user-select: none;
  }

  .jobsR img {
    width: 100%;
    display: block;
  }

  .jobs.is-in .jobsR {
    opacity: 1;
    transform: scale(1);
  }

  /* =========================
     RIGHT (2 COLUNAS NO DESKTOP)
  ========================= */
  .jobs__right {
    padding-top: 10px;
  }

  .jobsList {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)); /* 2 por linha */
    column-gap: 70px;
    row-gap: 26px;
  }

  /* stagger/appear */
  .jobsList .jobsItem {
    opacity: 0;
    transform: translateY(16px);
    transition:
      opacity 650ms ease,
      transform 650ms ease;
  }

  .jobsList.is-show .jobsItem {
    opacity: 1;
    transform: translateY(0);
  }

  .jobsItem {
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr); /* seta + texto */
    gap: 16px;
    align-items: start;
    padding: 0;
  }

  /* Seta (imagem) */
  .jobsItem__icon {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 2px;
  }

  	.jobsItem__icon img {
		width: 22px;
		height: auto;
		display: block;
		transform-origin: 50% 50%;
		transition: transform 650ms ease;
	}

	.jobsItem__icon img.is-rotating {
		transform: rotate(360deg);
	}

  .jobsItem__title {
    font-size: 22px;
    font-weight: 900;
    color: #0b2b2b;
    letter-spacing: -0.01em;
  }

  .jobsItem__desc {
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.55;
    color: rgba(11, 43, 43, 0.72);
    max-width: 520px;
  }

  /* NÃO existe seta da direita */
  .jobsItem__arrow {
    display: none !important;
  }

  /* =========================
     RESPONSIVO
  ========================= */
  @media (max-width: 1100px) {
    .jobs__inner {
      grid-template-columns: 1fr;
      gap: 34px;
      padding: 120px 24px 0;
    }

    .jobs__typing {
      font-size: 46px;
    }

    .jobsR {
      left: -60px;
      bottom: -240px;
      width: 300px;
      opacity: 0.35;
    }

    .jobsArrowTop {
      right: 18px;
      width: 80px;
      top: -35px;
    }

    .jobsFx--azul {
      width: 140px;
      top: -23px;
    }

    .jobsFx--branco {
      width: 40px;
      top: -63px;
    }
  }

  /* tablet/mobile: lista vira 1 coluna */
  @media (max-width: 980px) {
    .jobsList {
      grid-template-columns: 1fr;
      row-gap: 18px;
      column-gap: 0;
    }
  }

  @media (max-width: 520px) {
    .jobs__inner {
      padding: 105px 18px 0;
    }

    .jobs__typing {
      font-size: 38px;
    }

    .jobsLine {
      min-height: 44px;
    }

    .jobsCaret {
      height: 32px;
      transform: translateY(6px);
    }

    .jobsItem {
      grid-template-columns: 30px minmax(0, 1fr);
      gap: 12px;
    }

    .jobsItem__icon {
      width: 30px;
      height: 30px;
    }

    .jobsItem__icon img {
      width: 18px;
    }

    .jobsR {
      left: -40px;
      bottom: -40px;
      width: 280px;
      opacity: 0.28;
    }

    .jobsFx {
      left: -5px;
    }

    .cases__inner {
      padding: 0 10px;
    }
  }
`;

export const CssCases = styled.div`
  width: 100%;
  position: relative;
  z-index: 6;

  .cases {
    background: #e00000;
    position: relative;
    padding: 90px 0 90px;
  }

  .cases__inner {
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 24px;

    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    column-gap: 70px;
    align-items: start;
  }

  /* =======================
     LEFT
  ======================= */

  .cases__left {
    position: relative;
    padding-top: 20%;
    z-index: 2;
    width: 100%;
  }

  .cases__titleA {
    margin: 0;
    font-weight: 400;
    letter-spacing: -0.05em;
    color: #7cf3ff;
    font-size: 175px;
    line-height: 1;

    opacity: 0;
    transform: translateY(-34px);
    transition:
      opacity 900ms ease,
      transform 900ms ease;
    position: absolute;
    top: 10px;
    left: 0;
    width: 180%;

    strong {
      font-weight: 700;
    }
  }

  .cases__titleA.is-in {
    opacity: 1;
    transform: translateY(0);
  }

  .cases__titleB {
    font-weight: 500;
    color: #7cf3ff;
    font-size: 80px;
    line-height: 1.05;
    letter-spacing: -4px;

    opacity: 0;
    transform: translateY(34px);
    transition:
      opacity 900ms ease,
      transform 900ms ease;
    transition-delay: 140ms;

    position: absolute;
    top: 45%;
    left: 65%;
    width: 100%;

    strong {
      font-weight: 700;
    }
  }

  .cases__titleB.is-in {
    opacity: 1;
    transform: translateY(0);
  }

  .cases__photoPaWrap {
    position: relative;
    width: 430px;
    max-width: 100%;
    margin-top: 22px;

    opacity: 0;
    transform: translateX(-70px);
    transition:
      opacity 900ms ease,
      transform 900ms ease;
    transition-delay: 220ms;
  }

  .cases__photoPaWrap.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__photoPa {
    width: 100%;
    display: block;
  }

  .cases__zOverlay {
    position: absolute;
    right: -56px;
    bottom: -59px;
    width: 120px;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transform: translateX(-14px);
    transition:
      opacity 650ms ease,
      transform 650ms ease;
  }

  .cases__zOverlay.is-show {
    opacity: 1;
    transform: translateX(0);
  }

  /* =======================
     RIGHT
  ======================= */

  .cases__right {
    position: relative;
    display: grid;
    grid-template-rows: auto auto;
    row-gap: 22px;
    justify-items: end;
  }

  .cases__manWrap {
    width: 230px;
    max-width: 100%;

    opacity: 0;
    transform: translateY(90px) scale(0.78);
    transition:
      opacity 1200ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 1200ms cubic-bezier(0.16, 1, 0.3, 1);
    transition-delay: 260ms;
    position: absolute;
    right: 0;
    top: -120px;
  }

  .cases__manWrap.is-in {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

  .cases__man {
    width: 100%;
    display: block;
  }

  .cases__manOverlay {
    position: absolute;
    left: -120px;
    top: -22px;
    width: 230px;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transform: translateY(16px);
    transition:
      opacity 650ms ease,
      transform 650ms ease;
  }

  .cases__manOverlay.is-show {
    opacity: 1;
    transform: translateY(0);
  }

  .cases__descWrap {
    width: 650px;
    max-width: 100%;
    text-align: right;
    justify-self: center;
    margin-top: 45%;
  }

  .cases__desc {
    margin: 0 auto;
    max-width: 600px;
    color: #fff;
    font-size: 20px;
    line-height: 1.4;
    white-space: pre-line;
    min-height: 72px;

    opacity: 0;
    transform: translateX(-55px);
    transition:
      opacity 800ms ease,
      transform 800ms cubic-bezier(0.16, 1, 0.3, 1);
  }

  .cases__desc.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__caret,
  .cases__caret.is-on {
    display: none !important;
  }

  .btnTalk {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
    margin-right: 35px;
    padding: 10px 65px;
    border: 2px solid #77e7ff;
    background: #77e7ff;
    color: #e00000;
    text-decoration: none;
    font-weight: 700;
    text-transform: lowercase;
    will-change: transform, opacity;

    opacity: 0;
    visibility: hidden;
    transform: translate3d(-34px, 0, 0) skewX(-12deg);
    pointer-events: none;

    transition:
      opacity 700ms ease,
      transform 700ms cubic-bezier(0.16, 1, 0.3, 1),
      visibility 0ms linear 700ms;

    span {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      transform: skewX(16deg);
    }

    img {
      width: 20px;
      height: auto;
      display: block;
    }
  }

  .btnTalk.is-show {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0) skewX(-12deg);
    pointer-events: auto;
    transition:
      opacity 700ms ease,
      transform 700ms cubic-bezier(0.16, 1, 0.3, 1),
      visibility 0ms linear 0ms;
  }

  /* =======================
     CASES
  ======================= */

  .cases__videos {
    max-width: 1366px;
    margin: 0 auto 0;
    padding: 10px 5px;
    text-align: center;
  }

  .btnTalkCases {
    margin-right: 0;
    padding: 10px 35px;
    cursor: pointer;
  }

  /* =======================
     CASES LINKS
  ======================= */

  .cases__linksArea {
    width: 100%;
    position: relative;
    margin:-50px auto 80px;
    padding: 35px 0 65px;
    overflow: hidden;
    min-height: 430px;
  }

  .cases__barraBege {
    position: absolute;
    left: 0;
    top: 0;
    width: 423px;
    max-width: 32vw;
    height: auto;
    z-index: 0;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transform: translateX(-120px);
    will-change: opacity, transform;

    transition:
      opacity 900ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 900ms cubic-bezier(0.16, 1, 0.3, 1);
    transition-delay: 150ms;
  }

  .cases__barraBege.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__barraBegeVazia {
    position: absolute;
    right: 0;
    bottom: -100px;
    width: 274px;
    max-width: 22vw;
    height: auto;
    z-index: 0;
    pointer-events: none;
    user-select: none;

    opacity: 0;
    transform: translateX(120px);
    will-change: opacity, transform;

    transition:
      opacity 900ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 900ms cubic-bezier(0.16, 1, 0.3, 1);
    transition-delay: 420ms;
  }

  .cases__barraBegeVazia.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__linksTitle {
    width: 100%;
    max-width: 1366px;
    margin: -35px auto 50px;
    position: relative;
    z-index: 3;
    color: #7cf3ff;
    font-size: 70px;
    line-height: 0.95;
    font-weight: 400;
    letter-spacing: -0.055em;
    text-align: right;
    padding: 0 72px;
    box-sizing: border-box;

    opacity: 0;
    transform: translateX(110px);
    will-change: opacity, transform;

    transition:
      opacity 850ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 850ms cubic-bezier(0.16, 1, 0.3, 1);
    transition-delay: 260ms;

    strong {
      font-weight: 800;
    }
  }

  .cases__linksTitle.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__linksWrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    position: relative;
    z-index: 2;

    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px 14px;
    align-items: start;
  }

  .cases__linkCard {
    position: relative;
    display: block;
    width: 100%;
    height: auto;
    overflow: visible;
    text-decoration: none;
    background: transparent;

    opacity: 0;
    transform: translateX(-85px);
    will-change: opacity, transform;

    transition:
      opacity 850ms cubic-bezier(0.16, 1, 0.3, 1),
      transform 850ms cubic-bezier(0.16, 1, 0.3, 1);
  }

  .cases__linkCard.is-in {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__linkCard:nth-child(1) {
    grid-column: 1 / span 2;
  }

  .cases__linkCard:nth-child(2) {
    grid-column: 3 / span 2;
  }

  .cases__linkCard:nth-child(3) {
    grid-column: 5 / span 2;
  }

  .cases__linkCard:nth-child(4) {
    grid-column: 2 / span 2;
  }

  .cases__linkCard:nth-child(5) {
    grid-column: 4 / span 2;
  }

  .cases__linkCard img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    transform: scale(1);
    transition: transform 450ms ease;
  }

  .cases__linkCard:hover img {
    transform: scale(1.04);
  }

  .cases__linkCardOverlay,
  .cases__linkCardText {
    display: none;
  }

  /* =======================
     STATS
  ======================= */

  .cases__statsWrap {
    max-width: 1366px;
    margin: 100px auto 0;
    padding: 0 24px;
  }

  .cases__statsTitle {
    margin: 0 0 38px;
    text-align: center;
    color: #7cf3ff;
    font-size: 40px;
    line-height: 1.05;
    letter-spacing: -0.04em;
    font-weight: 700;
  }

  .cases__stats {
    max-width: 1366px;
    margin: 0 auto;
    padding: 0;

    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 34px 18px;
  }

  .stat {
    text-align: center;
  }

  .stat__num {
    color: #7cf3ff;
    font-weight: 600;
    letter-spacing: -0.02em;
    font-size: 68px;
    line-height: 1;
  }

  .stat__label {
    margin-top: 6px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    line-height: 1.3;
  }

  /* =======================
     TESTIMONIALS
  ======================= */

  .cases__testimonials {
    max-width: 1366px;
    margin: 35px auto 0;
    padding: 0 24px;
    position: relative;
  }

  .cases__testimonialsTitle {
    margin: 0 0 46px;
    text-align: center;
    color: #7cf3ff;
    font-size: 56px;
    line-height: 1.05;
    letter-spacing: -0.04em;
    font-weight: 700;
  }

  .cases__testimonialsNav {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-bottom: 15px;
    margin-top: -20px;
  }

  .cases__arrow {
    width: 35px;
    height: 35px;
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition:
      transform 250ms ease,
      opacity 250ms ease;
  }

  .cases__arrow:hover {
    opacity: 0.9;
  }

  .cases__arrow img {
    width: 28px;
    height: auto;
    display: block;
  }

  .cases__arrow--left img {
    transform: rotate(225deg);
  }

  .cases__arrow--right img {
    transform: rotate(405deg);
  }

  .cases__testimonialsGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 42px 54px;
    align-items: start;

    transition:
      opacity 260ms ease,
      transform 260ms ease;
    will-change: opacity, transform;
  }

  .cases__testimonialsGrid.is-visible {
    opacity: 1;
    transform: translateX(0);
  }

  .cases__testimonialsGrid.is-hidden.is-next {
    opacity: 0;
    transform: translateX(-22px);
  }

  .cases__testimonialsGrid.is-hidden.is-prev {
    opacity: 0;
    transform: translateX(22px);
  }

  .cases__testimonial {
    min-width: 0;
  }

  .cases__testimonialText {
    margin: 0;
    color: #fff;
    font-size: 17px;
    line-height: 1.45;
    font-style: italic;
    white-space: pre-line;
  }

  .cases__testimonialAuthor {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    gap: 3px;

    strong {
      color: #7cf3ff;
      font-size: 18px;
      line-height: 1.15;
      font-weight: 700;
    }

    span {
      color: rgba(255, 255, 255, 0.92);
      font-size: 14px;
      line-height: 1.3;
    }
  }

  @keyframes casesBlink {
    0%,
    49% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }

  /* =======================
     RESPONSIVO
  ======================= */

  @media (max-width: 1400px) {
    .cases__titleB {
      font-size: 85px;
    }

    .cases__testimonialsTitle,
    .cases__statsTitle {
      font-size: 50px;
    }
  }

  @media (max-width: 1280px) {
    .cases__titleA {
      font-size: 145px;
    }

    .cases__titleB {
      font-size: 78px;
    }

    .cases__linksTitle {
      font-size: 66px;
      padding: 0 48px;
    }

    .cases__stats {
      margin: 50px auto 0;
    }

    .cases__testimonialsTitle,
    .cases__statsTitle {
      font-size: 44px;
    }
  }

  @media (max-width: 1100px) {
    .cases__inner {
      grid-template-columns: 1fr;
      row-gap: 26px;
    }

    .cases__right {
      justify-items: start;
    }

    .cases__descWrap {
      text-align: left;
      justify-self: start;
    }

    .cases__stats {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      margin-top: 42px;
    }

    .cases__testimonialsGrid {
      gap: 34px 28px;
    }
  }

  @media (max-width: 1024px) {
    .cases__left {
      padding-top: 11%;
      width: 100%;
    }

    .cases__titleA {
      font-size: 120px;
      top: 20px;
      width: 100%;
    }

    .cases__titleB {
      font-size: 60px;
      left: 40%;
      width: 60%;
    }

    .cases__manWrap {
      top: -331%;
      width: 170px;
      display: none;
    }

    .cases__descWrap {
      margin-top: 5%;
      text-align: right;
    }

    .cases__linksArea {
      margin: 50px auto 65px;
      padding: 35px 24px 55px;
      min-height: auto;
    }

    .cases__linksTitle {
      font-size: 54px;
      text-align: center;
      padding: 0 20px;
      margin-bottom: 26px;
    }

    .cases__linksWrap {
      max-width: 760px;
      gap: 10px 12px;
    }

    .cases__barraBege {
      max-width: 42vw;
    }

    .cases__barraBegeVazia {
      max-width: 30vw;
      bottom: -120px;
    }

    .cases__testimonialsTitle,
    .cases__statsTitle {
      font-size: 38px;
      margin-bottom: 34px;
    }
  }

  @media (max-width: 768px) {
    .cases__linksArea {
      margin: 45px auto 45px;
      padding: 40px 18px 45px;
    }

    .cases__linksTitle {
      font-size: 42px;
      line-height: 1;
      text-align: center;
      padding: 0 12px;
      margin-bottom: 22px;
      transform: translateX(70px);
    }

    .cases__linksTitle.is-in {
      transform: translateX(0);
    }

    .cases__linksWrap {
      max-width: 100%;
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .cases__linkCard:nth-child(1),
    .cases__linkCard:nth-child(2),
    .cases__linkCard:nth-child(3),
    .cases__linkCard:nth-child(4),
    .cases__linkCard:nth-child(5) {
      grid-column: auto;
    }

    .cases__linkCard {
      max-width: 360px;
      margin: 0 auto;
    }

    .cases__barraBege {
      width: 310px;
      max-width: 70vw;
    }

    .cases__barraBegeVazia {
      width: 210px;
      max-width: 48vw;
      bottom: -130px;
    }

    .cases__testimonials {
      margin-top: 60px;
    }

    .cases__testimonialsTitle,
    .cases__statsTitle {
      font-size: 30px;
      margin-bottom: 24px;
    }

    .cases__testimonialsNav {
      justify-content: center;
      margin-bottom: 20px;
    }

    .cases__testimonialsGrid {
      grid-template-columns: 1fr;
      gap: 28px;
    }

    .cases__testimonialText {
      font-size: 16px;
      line-height: 1.5;
    }

    .cases__testimonialAuthor {
      strong {
        font-size: 17px;
      }

      span {
        font-size: 13px;
      }
    }
  }

  @media (max-width: 520px) {
    .cases {
      padding: 64px 0 70px;
    }

    .cases__left {
      padding-top: 25%;
    }

    .cases__titleA {
      font-size: 46px;
      top: 5px;
    }

    .cases__descWrap {
      width: 100%;
      margin-top: 15%;
    }

    .cases__desc {
      font-size: 18px;
      line-height: 23px;
      letter-spacing: -1px;
      white-space: normal;
    }

    .cases__titleB {
      font-size: 25px;
      left: 15%;
      width: 85%;
      top: 20%;
      letter-spacing: 0;
    }

    .cases__linksArea {
      padding: 35px 16px 35px;
      margin: 35px auto 35px;
    }

    .cases__linksTitle {
      font-size: 34px;
      line-height: 1;
      padding: 0 8px;
      margin-bottom: 18px;
      text-align: left;
      transform: translateX(55px);
    }

    .cases__linksTitle.is-in {
      transform: translateX(0);
    }

    .cases__linksWrap {
      gap: 13px;
    }

    .cases__linkCard {
      max-width: 100%;
    }

    .cases__barraBege {
      width: 260px;
      max-width: 75vw;
    }

    .cases__barraBegeVazia {
      width: 180px;
      max-width: 55vw;
      bottom: -120px;
    }

    .cases__statsWrap {
      margin: 25px auto 0;
    }

    .cases__photoPaWrap {
      width: 85%;
    }

    .cases__manWrap {
      width: 240px;
    }

    .btnTalk {
      margin-right: 0;
      padding: 10px 18px;
    }

    .cases__stats {
      gap: 24px 14px;
    }

    .stat__num {
      font-size: 50px;
    }

    .cases__testimonialsTitle,
    .cases__statsTitle {
      font-size: 22px;
      line-height: 1.15;
    }

    .cases__arrow {
      width: 40px;
      height: 40px;
    }

    .cases__arrow img {
      width: 24px;
    }
  }
`;

export const CssContato = styled.div`
  width: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  z-index: 8;

  .typingCaret {
    display: inline-block;
    margin-left: 2px;
    animation: blinkCaret 0.8s step-end infinite;
  }

  @keyframes blinkCaret {
    50% {
      opacity: 0;
    }
  }

  #LoadingPage {
    display: none;
  }

  #faleConosco {
    width: 100%;
    position: relative;
  }

  .container {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 28px;
    position: relative;
    z-index: 2;
  }

  .decor {
    position: absolute;
    pointer-events: none;
    z-index: 1;
  }

  .decor__piece {
    position: absolute;
    will-change: transform, opacity;
    user-select: none;
    opacity: 0;
  }

  /* =========================
     BLOCO 1
  ========================= */
  .contactTop {
    position: relative;
    background: #80edff;
    padding: 42px 0 56px;
  }

  .decor--topLeft {
    top: -30px;
    left: 0;
    width: 260px;
    height: 180px;
  }

  .decor--topLeft .decor__piece--white {
    top: 0;
    left: 0;
    width: 170px;
    transform: translate3d(-180px, 0, 0);
    transition: transform 1.8s ease, opacity 1.8s ease;
  }

  .decor--topLeft.is-active .decor__piece--white {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .setaScroll {
    position: absolute;
    top: -50px;
    right: 90px;
    width: 102px;
    z-index: 1;
    pointer-events: none;
    transform-origin: 72% 28%;
    will-change: transform;
    transition: transform 0.08s linear;
  }

  .teamGrid {
    display: grid;
    grid-template-columns: 140px 1fr 1.2fr;
    align-items: center;
    gap: 34px;
    min-height: 460px;
  }

  .teamTitle {
    color: #ff1a00;
    font-weight: 700;
    font-size: 22px;
    line-height: 0.95;
    opacity: 0;
    transform: translate3d(-60px, 0, 0);
    transition: opacity 0.9s ease, transform 0.9s ease;
    align-self: center;
    justify-self: start;
    white-space: pre-line;
  }

  .teamTitle span {
    display: block;
  }

  .teamTitle.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .teamPhotoWrap {
    opacity: 0;
    transform: translate3d(0, -70px, 0);
    transition: opacity 1s ease, transform 1s ease;
    justify-self: center;
    width: 100%;
    max-width: 360px;
  }

  .teamPhotoWrap.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .teamPhoto {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .teamTextWrap {
    display: flex;
    align-items: center;
    min-height: 320px;
  }

  .teamText {
		white-space: pre-line;
		color: #173644;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 500;
		max-width: 420px;
	}

	.teamText__name {
		font-size: 18px;
		font-weight: 700;
		line-height: 1.15;
		margin: 0 0 2px;
	}

	.teamText__role {
		font-size: 15px;
		font-weight: 400;
		line-height: 1.25;
		opacity: 0.9;
		margin: 0 0 12px;
	}

	.teamText__space {
		height: 8px;
	}

  /* =========================
     BLOCO 2
  ========================= */
  .contactBottom {
    position: relative;
    background: #efe7d4;
    padding: 78px 0 34px;
  }

  .bottomZWrap {
    position: absolute;
    left: 28px;
    top: -20px;
    width: 120px;
    height: 120px;
    pointer-events: none;
    z-index: 1;
  }

  .bottomZ {
    width: 100%;
    opacity: 0;
    transform: translate3d(180px, 0, 0);
    transition: transform 2.2s ease, opacity 2.2s ease;
  }

  .bottomZWrap.is-active .bottomZ {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .tarjaWrap {
    position: absolute;
    top: -92px;
    right: 0;
    width: 210px;
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transform: translate3d(-100px, 0, 0);
    transition: opacity 1s ease, transform 1s ease;
  }

  .tarjaWrap.is-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  .tarjaVermelha {
    width: 100%;
    display: block;
  }

  .vamosFalarTitle {
    text-align: center;
    font-size: 58px;
    line-height: 1;
    font-weight: 700;
    padding: 0;
    margin: 0 0 40px;
    color: #ff1a00;
    position: relative;
    z-index: 2;
  }

  /* =========================
     FORMULÁRIO
  ========================= */
  #formulario {
    width: 100%;
    max-width: 620px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }

  #formulario form {
    width: 100%;
  }

  #formulario ::-webkit-input-placeholder {
    color: #ff1a00;
    font-family: "Barlow", serif;
  }

  .input-branco::placeholder {
    color: #ff1a00;
    opacity: 1;
    font-family: "Barlow", serif;
    font-size: 16px;
    font-weight: 600;
  }

  #formulario input[type="text"],
  #formulario textarea {
    float: left;
    width: 100%;
    background: #80edff;
    border: none;
    padding: 0 16px;
    color: #ff1a00;
    font-size: 18px;
    font-weight: 600;
    transition: 0.35s;
    height: 54px;
    margin: 0 0 18px;
    outline: none;
    box-sizing: border-box;
    font-family: "Barlow", serif;
  }

  #formulario textarea {
    min-height: 84px;
    padding-top: 16px;
    resize: none;
  }

  #formulario input[type="text"]:focus,
  #formulario textarea:focus {
    box-shadow: 0 0 0 1px rgba(255, 26, 0, 0.18);
  }

  #formulario button {
	display: block;
	width: 150px;
	height: 44px;
	margin: 18px auto 0;
	background: transparent;
	border: none;
	color: #e00700;
	font-size: 20px;
	font-weight: 700;
	cursor: pointer;
	font-family: "Barlow", serif;
	position: relative;
	z-index: 1;
	transition: color 0.25s ease;
	}

	#formulario button::before {
	content: "";
	position: absolute;
	inset: 0;
	border: 2px solid #ff1a00;
	transform: skewX(-28deg);
	transform-origin: center;
	z-index: -1;
	transition: background 0.25s ease, border-color 0.25s ease;
	}

	#formulario button:hover {
	color: #fff;
	}

	#formulario button:hover::before {
	background: #e00700;
	border-color: #e00700;
	}

	#formulario button:disabled {
	opacity: 0.7;
	cursor: not-allowed !important;
	}

	#formulario button:disabled::before {
	background: transparent;
	border-color: #ff1a00;
	}

	#Aguarde::before {
		content: "";
		position: absolute;
		inset: 0;
		border: 2px solid #ff1a00;
		transform: skewX(-28deg);
		transform-origin: center;
		z-index: -1;
	}

  /* =========================
     FOOTER
  ========================= */
  .footerBar {
    width: 100%;
    margin-top: 54px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 24px;
    position: relative;
    z-index: 2;
  }

  #redes {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 24px;
    font-weight: 300;
  }

  #redes a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  #redes img {
    opacity: 0.75;
    transition: 0.2s;
    cursor: pointer;
    width: 22px;
  }

  #redes img:hover {
    opacity: 1;
    transform: translateY(-1px) scale(1.08);
  }

  #logotipos {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 32px;
    flex-wrap: nowrap;
  }

  #logotipos img {
    height: auto;
    object-fit: contain;
  }

  #logotipos img:first-child {
    max-width: 132px;
  }

  #logotipos img:last-child {
    max-width: 104px;
  }

  /* =========================
     RESPONSIVO
  ========================= */
  @media only screen and (max-width: 1100px) {
    .teamGrid {
      grid-template-columns: 110px 300px 1fr;
      gap: 24px;
    }

    .teamText {
      font-size: 16px;
      max-width: 360px;
    }

    .vamosFalarTitle {
      font-size: 50px;
    }

    .setaScroll {
      width: 95px;
      right: 46px;
    }
  }

  @media only screen and (max-width: 900px) {
    .contactTop {
      padding: 52px 0 44px;
    }

    .teamGrid {
      grid-template-columns: 1fr;
      gap: 22px;
      min-height: auto;
      justify-items: center;
      text-align: center;
    }

    .teamTitle {
      justify-self: center;
      font-size: 34px;
      line-height: 0.9;
    }

    .teamPhotoWrap {
      max-width: 320px;
    }

    .teamTextWrap {
      min-height: auto;
      justify-content: center;
    }

    .teamText {
      text-align: left;
      max-width: 420px;
    }

    .vamosFalarTitle {
      font-size: 44px;
    }

    .footerBar {
      flex-direction: column;
      align-items: center;
      gap: 26px;
    }

    #logotipos {
      justify-content: center;
    }

    .tarjaWrap {
      width: 150px;
	  top:-50px
    }
  }

  @media only screen and (max-width: 768px) {
    .container {
      padding: 0 18px;
    }

    .decor--topLeft {
      width: 180px;
      height: 120px;
    }

    .decor--topLeft .decor__piece--white {
      width: 110px;
    }

    .setaScroll {
      width: 70px;
      top: -22px;
      right: 70px;
    }

    .teamTitle {
      font-size: 28px;
    }

    .teamPhotoWrap {
      max-width: 270px;
    }

    .teamText {
      font-size: 15px;
      line-height: 1.5;
    }

    .contactBottom {
      padding: 62px 0 28px;
    }

    .bottomZWrap {
      width: 78px;
      left: 14px;
       top: -20px;
    }

    .vamosFalarTitle {
      font-size: 36px;
      margin-bottom: 28px;
    }

    #formulario input[type="text"],
    #formulario textarea {
      font-size: 18px;
      height: 52px;
      margin-bottom: 14px;
    }

    #formulario textarea {
      min-height: 82px;
    }

    #formulario button {
      width: 120px;
      height: 42px;
      font-size: 18px;
    }

    #redes {
      gap: 14px;
    }

    #logotipos {
      gap: 20px;
      flex-wrap: wrap;
    }

    #logotipos img:first-child {
      max-width: 120px;
    }

    #logotipos img:last-child {
      max-width: 92px;
    }
  }

  @media only screen and (max-width: 480px) {
    .contactTop {
      padding: 46px 0 38px;
    }

    .teamTitle {
      font-size: 24px;
    }

    .teamPhotoWrap {
      max-width: 220px;
    }

    .teamText {
      font-size: 14px;
    }

    .vamosFalarTitle {
      font-size: 30px;
    }

    .tarjaWrap {
      width: 118px;
    }

    #formulario input[type="text"],
    #formulario textarea {
      font-size: 16px;
      padding: 0 12px;
    }

    #formulario textarea {
      padding-top: 14px;
    }

    #redes img {
      width: 20px;
    }

    #logotipos img:first-child {
      max-width: 108px;
    }

    #logotipos img:last-child {
      max-width: 86px;
    }
  }
`;
